// extracted by mini-css-extract-plugin
export var cardIcon = "_76-4";
export var checkboxCard = "_76-0";
export var checkboxCardSelected = "_76-3";
export var disabled = "_76-1";
export var outerBorder = "_76-2";
export var spacerMedium = "_76-7";
export var spacerSmall = "_76-6";
export var spacerXsmall = "_76-5";